/**
 * Determines which half of the vehicle-journey pairing the site is missing. The edge can only emit a
 * `vehicle_journey` when a start zone and an end zone both exist, and the design shows a
 * different message for each case.
 *
 * `null` means the pairing is complete and the widget can show a value.
 */
export type MissingJourneyZones = 'both' | 'start' | 'end' | null;

export function getMissingJourneyZones(
  hasStartZone: boolean,
  hasEndZone: boolean,
): MissingJourneyZones {
  if (!hasStartZone && !hasEndZone) return 'both';
  if (!hasStartZone) return 'start';
  if (!hasEndZone) return 'end';
  return null;
}
